/* eslint-disable */
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import { Box, Card, Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Stack, TextField, CardContent, Button, Typography
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'react-toastify';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Services';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecord: {
        backgroundColor: "green",
    },
    bold: {
        fontWeight: 600,
    }
}));

export default function MarketAddEdit() {
    const screenCode = 'MARKET';
    const classes = useStyles();   
    const navigate = useNavigate();

    const [isButtonEnable, setIsButtonEnable] = useState(false);
    const [marketID, setMarketID] = useState("")
    const [groupList, setGroupList] = useState([]);
    const [checked, setChecked] = useState([]);
    const [LeftNewArray, setLeftNewArray] = useState([]);
    const [RightNewArray, setRightNewArray] = useState([]);
    const [RightNewArrayAlreadyStoredAccounts, setRightNewArrayAlreadyStoredAccounts] = useState([])
    const [RemovedLedgerAccountList, setRemovedLedgerAccountList] = useState([]);
    const [canEdit, setCanEdit] = useState({
        editFactory: false
    });

    const [formData, setFormData] = useState({
        groupID: "0",
        createdBy: "",
        marketCode: "",
        marketName: "",
        marketDescription: "",
        isActive: true
    });

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: false,
        submitButtonName: "Save",
        pageName: "Add Market"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });

    const SearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        marketCode: Yup.string().matches(/^[A-Za-z0-9!@#\$%\^\&*\)\(+=._-]+$/, 'Invalid Market Code').required('Market Code required'),
        marketName: Yup.string().matches(/^(?!.*[\s]{2})(?!^[\s]|[\s]$)(?=.*[a-zA-Z])(?=.*[\d])?(?!^[\d\s]+$)(?!^[^\w\s]+$)[\w\s\p{S}]+$/, 'Invalid Market Name').required('Market Name required')
    });

    const { operationEntityID } = useParams();

    const leftChecked = intersection(checked, LeftNewArray);
    const rightChecked = intersection(checked, RightNewArray);

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
            isActive: formData.isActive,
            marketCode: formData.marketCode,
            marketName: formData.marketName,
            marketDescription: formData.marketDescription,
        },

        validationSchema: SearchSchema,
        onSubmit: () => {
            trackPromise(SubmitForm());
        }
    });
    
    let decrypted = 0;

    useEffect(() => {
        decrypted = AESDecryptionParam(operationEntityID);
        if (decrypted > 0) {
            setPageProps({
                ...pageProps,
                isEdit: true,
                submitButtonName: "Update",
                editingID: parseInt(decrypted),
                pageName: "Edit Market"
            })
            setCanEdit({
                ...canEdit,
                editFactory: true
            });
            setMarketID(decrypted);
            SetDetailsForFactoryEdit(decrypted);
        }
    }, []);

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        getPermissions();
    }, [])

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'MARKET');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        });
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForMarketScreen();
        if (res != null) {
            setGroupList(res);
        }
        GetAllFactoriesByGroupID();
    }

    async function GetAllFactoriesByGroupID() {
        var res = await services.GetAllFactoriesByGroupID(1);
        if (res != null) {
            if (RightNewArray.length === 0) {
                res.length === 0 ?
                    setLeftNewArray([]) :
                    setLeftNewArray(res)
            }
            else {
                await SetAndFilterMainLedgerAccountListArrays(res, RightNewArray)
            }
        }
    }

    async function SubmitForm() {

        if (canEdit.editFactory === false) {
            let model = {
                groupID: values.groupID,
                marketCode: values.marketCode,
                marketName: values.marketName,
                marketDescription: values.marketDescription,
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                isActive: values.isActive,
                linkedProductList: not(RightNewArray, RightNewArrayAlreadyStoredAccounts),
            }

            let res = await services.SaveMarketDetails(model);
            if (res.statusCode === "Success") {
                ClearAllArrays();
                toast.success("New Market Added Succesfully");
                formik.resetForm();
                setTimeout(() => {
                    navigate('/dashboard/viewMarket');
                }, 1000);
                setIsButtonEnable(true);
            } else {
                toast.error(res.message);
            }
        }
        else if (canEdit.editFactory != false) {

            let model = {
                groupID: values.groupID,
                marketCode: values.marketCode,
                marketName: values.marketName,
                marketID: parseInt(marketID),
                marketDescription: values.marketDescription,
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                isActive: values.isActive,
                linkedProductList: RightNewArray,
                removedLinkedAccountList: RemovedLedgerAccountList
            }

            let res = await services.UpdateMarketDetails(model);
            if (res.statusCode === "Success") {
                toast.success(res.message);
                setTimeout(() => {
                    navigate('/dashboard/viewMarket');
                    SetDetailsForFactoryEdit(marketID);
                }, 3000);
            } else {
                toast.error(res.message);
                SetDetailsForFactoryEdit(marketID);
            }
        }
        else {
            toast.error(res.message);
        }
    }

    async function SetDetailsForFactoryEdit(marketID) {

        if (canEdit != false) {
            let result = await services.GetMarketByMarketIDFromMarketScreen(marketID);

            setValues({
                groupID: result[0].groupID,
                marketCode: result[0].marketCode,
                marketName: result[0].marketName,
                marketDescription: result[0].marketDescription,
                isActive: result[0].isActive,
            })

            const allFactories = await services.GetAllFactoriesByGroupID(result[0].groupID);
            if (result[0].linkedProductList === 0) {
                setRightNewArray([]);
                setRightNewArrayAlreadyStoredAccounts([])
            } else {
                setRightNewArray(result[0].linkedProductList)
                setRightNewArrayAlreadyStoredAccounts(result[0].linkedProductList)
                setRemovedLedgerAccountList(RemovedLedgerAccountList.concat(result[0].linkedProductList))
            }
            const inter = await SetAndFilterMainLedgerAccountListArrays(allFactories, result[0].linkedProductList)
        }
    }

    async function SetAndFilterMainLedgerAccountListArrays(productDetails, linkedAccountList) {
        const filteredAccountList = not(productDetails, linkedAccountList)
        filteredAccountList.length === 0 ?
            setLeftNewArray([]) :
            setLeftNewArray(filteredAccountList);

        return filteredAccountList;
    }

    function intersection(a, b) {
        return a.filter((value) => b.map(obj => obj.factoryID).indexOf(value.factoryID) !== -1);
    }

    function not(a, b) {
        return a.filter((value) => b.map(obj => obj.factoryID).indexOf(value.factoryID) === -1);
    }

    function intersection(a, b) {
        return a.filter((value) => b.map(obj => obj.factoryID).indexOf(value.factoryID) !== -1);
    }

    function ClearAllArrays() {
        setChecked([])
        setLeftNewArray([])
        setRightNewArray([])
        setRightNewArrayAlreadyStoredAccounts([])
        setRemovedLedgerAccountList([])
    }

    function clearAll() {
        setValues({
            ...values,
            marketCode: "",
            marketName: "",
            marketDescription: "",
            isActive: false
        })
    }

    const customList = (items) => (
        items.length > 0 ? (
            <Paper className={classes.paper}>
                <List dense={true} component="div" role="list" sx={{
                    position: 'relative',
                    overflow: 'auto',
                    maxHeight: 300
                }}>
                    {items.map((value) => {
                        const labelId = `transfer-list-item-${value.factoryID}-label`;
                        return (
                            <ListItem key={value.factoryID} role="listitem" button onClick={handleToggle(value)}>
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checked.map(obj => obj.factoryID).indexOf(value.factoryID) !== -1}
                                        tabIndex={-1}
                                        color='secondary'
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.factoryName} />
                            </ListItem>
                        );
                    })}
                </List>
            </Paper>
        ) : null
    );

    const handleToggle = (value) => (event) => {
        setChecked(prevChecked => {
            if (prevChecked.find(item => item.factoryID === value.factoryID)) {
                return prevChecked.filter(item => item.factoryID !== value.factoryID);
            } else {
                return [...prevChecked, value];
            }
        });
    };

    const handleCheckedRight = () => {
        setRemovedLedgerAccountList(RemovedLedgerAccountList.concat(leftChecked))
        setRightNewArray(RightNewArray.concat(leftChecked));
        setLeftNewArray(not(LeftNewArray, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {
        setRemovedLedgerAccountList(RemovedLedgerAccountList.concat(rightChecked))
        setLeftNewArray(LeftNewArray.concat(rightChecked));
        setRightNewArray(not(RightNewArray, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    return (
        <>
            <LoadingComponent />
            <Page title="Add Market |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/viewMarket"}
                        btname="Back"
                        pageName={pageProps.pageName}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Market Code *"
                                        value={formik.values.marketCode}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('marketCode')}
                                        error={Boolean(touched.marketCode && errors.marketCode)}
                                        helperText={touched.marketCode && errors.marketCode} s
                                    />
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Market Name *"
                                        value={formik.values.marketName}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('marketName')}
                                        error={Boolean(touched.marketName && errors.marketName)}
                                        helperText={touched.marketName && errors.marketName}
                                    />
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Market Description "
                                        value={formik.values.marketDescription}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('marketDescription')}
                                        error={Boolean(touched.marketDescription && errors.marketDescription)}
                                        helperText={touched.marketDescription && errors.marketDescription}
                                    />
                                </Stack>
                                <Card>
                                    <CardContent>
                                        <Box marginTop={4} />
                                        {
                                            RightNewArray.length > 0 || LeftNewArray.length > 0 ?
                                                <Grid container spacing={3}>
                                                    <Grid item md={5} xs={12} >
                                                        <Typography variant='h5'>Fresh Collection Center</Typography> <br />
                                                        {customList(LeftNewArray)}
                                                    </Grid>
                                                    <Grid item md={2} xs={12}>
                                                        <Grid container direction="column" alignItems="center" style={{ marginTop: "30%" }}>
                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                color='secondary'
                                                                className={classes.button}
                                                                onClick={handleCheckedRight}
                                                                disabled={leftChecked.length === 0}
                                                                aria-label="move selected right"
                                                            >
                                                                &gt;
                                                            </Button>
                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                color='secondary'
                                                                className={classes.button}
                                                                onClick={handleCheckedLeft}
                                                                disabled={rightChecked.length === 0}
                                                                aria-label="move selected left"
                                                            >
                                                                &lt;
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item md={5} xs={12}>
                                                        <Typography variant='h5'>Mapped Fresh Collection Center</Typography> <br />
                                                        {customList(RightNewArray)}
                                                    </Grid>
                                                </Grid>
                                                : null}
                                    </CardContent>
                                </Card>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                value={formik.values.isActive}
                                                checked={formik.values.isActive}
                                                {...getFieldProps('isActive')}
                                                onClick={formik.handleChange}
                                                color='error'
                                                name="isActive"
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                            />}
                                        label="Is Active"
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color='error'
                                        onClick={() => clearAll()}
                                    > Clear</Button>
                                    <Button
                                        disabled={isButtonEnable}
                                        type="submit"
                                        variant="contained"
                                        color='secondary'
                                    >{pageProps.submitButtonName}</Button>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}

